import React from 'react';

export const Reel_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Reel Post</span>,
  },
];

export const ReelSub_Title = [
  {
    textSize: '1rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Las piezas exhibidas forman parte del trabajo realizado por KUTER Casa
        Productora en colaboración con distintos clientes. Todos los derechos de
        propiedad intelectual de las obras pertenecen a sus respectivos
        titulares.
      </span>
    ),
  },
];

export const Betcris_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>BETCRIS - NO IMPORTA EL DEPORTE</span>,
  },
];

export const Charly_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Charly</span>,
  },
];

export const ImagenRadio_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Imagen Radio</span>,
  },
];

export const Teleton_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Teletón</span>,
  },
];

export const Interceramic_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Interceramic</span>,
  },
];

export const Lg_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>LG</span>,
  },
];

export const Warner_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>Warner Music</span>,
  },
];
